import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { ProjectStatus } from 'app/constant/common.constant';
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';

import { MatSelect } from "@angular/material";
import { AuthService } from "app/core/services/auth.service";
import { BehaviorSubject } from "rxjs";
import { locale as danish } from './translate/ds';
import { locale as english } from './translate/en';


@Component({
    selector: 'project-status',
    templateUrl: './project-status.component.html',
    styleUrls: ['./project-status.component.scss'],
})

export class ProjectStatusComponent implements OnInit {
    //@Input() RequisitionStatus: string;
    private _RequisitionStatus = new BehaviorSubject<number>(null);
    @Input()
    set RequisitionStatus(value) {
        this._RequisitionStatus.next(value);
    };
    get RequisitionStatus() {
        return this._RequisitionStatus.getValue();
    }

    @Output() Status = new EventEmitter();
    @ViewChild('myMatSelect', { static: true }) myMatSelect: MatSelect;

    requisitionStatus: any;
    selectStatus = ProjectStatus;
    tempRequisitionStatus: any = "";
    projectStatusList = ProjectStatus;
    roleClaims: any;
    isShowInvoiceStatus: boolean = false;

    constructor(private translationLoader: FuseTranslationLoaderService,
        private translate: TranslateService,
        private authService: AuthService) {
        this.translationLoader.loadTranslations(english, danish);
        this.roleClaims = this.authService.getRoleClaimsList();
    }

    ngOnInit() {
        this._RequisitionStatus
            .subscribe(val => {
                this.requisitionStatus = val;
            });
        this.authService.hasClaim(this.roleClaims.Generate_Project_Invoice).subscribe(hasClaim => {
            if (hasClaim)
                this.isShowInvoiceStatus = hasClaim
            else
                this.isShowInvoiceStatus = false;
        });
    }

    DropDownSearchRequisitionStatus(value) {
        this.selectStatus = this.projectStatusList;
        if (value) {
            if (this.translate.store.currentLang == "en")
                this.selectStatus = this.projectStatusList.filter(x => x.en.toLowerCase().includes(value.toLowerCase()));
            else
                this.selectStatus = this.projectStatusList.filter(x => x.ds.toLowerCase().includes(value.toLowerCase()));
        }
        else
            this.selectStatus = this.projectStatusList;
    }

    onChangeStatus(SelectedStatusID) {
        if (SelectedStatusID == 10 && !this.isShowInvoiceStatus)
            return;
        this.myMatSelect.value = this.requisitionStatus
        this.Status.emit(SelectedStatusID);
    }
}